import { useEffect, useRef } from 'react';

import { ShortcutMenuContextAction, ShortcutMenuContextActionRegistration } from '../components/ShortcutMenuContext';

import { useShortcutMenu } from './useShortcutMenu';

const getContextActionsSignature = (contextActions: ShortcutMenuContextAction[]) =>
    contextActions
        .map((action) => `${action.id}:${action.label}:${action.destructive ? '1' : '0'}:${action.Icon?.name ?? ''}`)
        .join('|');

export const useRegisterShortcutMenuContextActions = (contextActions: ShortcutMenuContextActionRegistration[]) => {
    const { setContextActions, setContextActionHandlers, clearContextActionHandlers } = useShortcutMenu();
    const previousSignatureRef = useRef('');
    const visibleContextActions: ShortcutMenuContextAction[] = contextActions.map((action) => ({
        id: action.id,
        label: action.label,
        Icon: action.Icon,
        destructive: action.destructive,
    }));
    const currentSignature = getContextActionsSignature(visibleContextActions);

    useEffect(() => {
        setContextActionHandlers(Object.fromEntries(contextActions.map((action) => [action.id, action.onSelect])));

        if (previousSignatureRef.current === currentSignature) {
            return;
        }

        previousSignatureRef.current = currentSignature;
        setContextActions(visibleContextActions);
    }, [contextActions, currentSignature, setContextActionHandlers, setContextActions, visibleContextActions]);

    useEffect(
        () => () => {
            previousSignatureRef.current = '';
            setContextActions([]);
            clearContextActionHandlers();
        },
        [clearContextActionHandlers, setContextActions]
    );
};
